// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresentation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import DashboardTile from '../DashboardGrid/DashboardTile/Izenda.DashboardTile';
import SliderBox from 'share/components/controls/Izenda.SliderBox';
import { map, uniqueId } from 'lodash/fp';
const SCREEN_RATIO = 7;

@observer
class DashboardPresentation extends Component {
  static propTypes = {
    store: PropTypes.object
  };

  @observable width = null;

  constructor(props: Object) {
    super(props);
    this.width = props.width;
  }

  componentDidMount() {
    let containerDOM = ReactDOM.findDOMNode(this);
    let newWidth = containerDOM.clientWidth;
    newWidth > 0 && newWidth !== this.width && (this.width = newWidth);
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.width > 0 && nextProps.width !== this.width){
      this.width = nextProps.width;
    }
  }

  render() {
    let { dashboardDetail } = this.props.store;
    let centerPadding = Math.round(this.width / SCREEN_RATIO);
    let settings = null;

    if (dashboardDetail.dashboard.activeDashboardParts.length > 1) {
      settings = {
        centerMode: true,
        centerPadding: centerPadding,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        lazyLoad: true,
        draggable: false
      };
    }

    // Effect when resize event
    let style = {
      width: this.width ? +this.width + 'px' : '100%'
    };

    const dashboardTileStyle = {
      width: this.width ? this.width - centerPadding * 2 : '100%'
    };

    /**
     * Render dashboard tiles
     */
    const renderDashboardTiles = () => {
      return map(
        dashboardPart => (
          <div key={dashboardPart.id} className="u_fullHeight">
            <DashboardTile
              {...this.props}
              dashboardPart={dashboardPart}
              dashboardTileStyle={dashboardTileStyle}
              viewMode
              presentationMode
            />
          </div>
        ),
        dashboardDetail.dashboard.activeDashboardParts
      );
    };

    /**
     * Render slider box
     */
    return (
      <div className="u_fullHeight" style={style}>
        {dashboardDetail.dashboard.activeDashboardParts.length > 1 ? (
          <SliderBox settings={settings} className="izenda-DashboardPresentation-SliderContainer" key={uniqueId()}>
            {renderDashboardTiles()}
          </SliderBox>
        ) : (
          renderDashboardTiles()
        )}
      </div>
    );
  }
}

export default DashboardPresentation;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardPresentation/Izenda.DashboardPresentation.js